import { useState, useEffect } from "react";
import { sliderData } from "../data";

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % sliderData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-[600px] lg:h-[860px] overflow-hidden">
      {sliderData.map(({ id, title, bg, btnNext }, index) => (
        <div
          key={id}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === current
              ? "opacity-100 z-10"
              : "opacity-0 z-0"
          }`}
        >
          {/* Background */}
          <img
            src={bg}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/70" />

          {/* Content */}
          <div className="relative z-20 flex flex-col items-center justify-center h-full text-center text-white px-4">
            <div className="uppercase tracking-[6px] mb-5">
              Just Enjoy & Relax
            </div>

            <h1 className="font-bold text-[32px] lg:text-[68px] uppercase tracking-[2px] leading-tight max-w-[920px] mb-6">
              {title}
            </h1>

            <button
              type="button"
              onClick={() => {document.getElementById("rooms")?.scrollIntoView({ behavior: "smooth" });}}
              className="px-8 py-3 bg-white text-black font-medium rounded hover:scale-105 transition-transform"
            >
              {btnNext}
            </button>
          </div>
        </div>
      ))}

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex gap-3">
        {sliderData.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              current === index
                ? "bg-white scale-125"
                : "bg-white/40"
            }`}
          />
        ))}
      </div>
    </section>
  );
}